/**
 * Custom error for indicating timeouts
 * @namespace _converse
 */
export class TimeoutError extends Error {}
